var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInTreatmentBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11139_6905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 3.66669C7.28384 3.27602 6.27784 2.66669 5.33317 2.66669C3.93317 2.66669 2.6665 3.49802 2.6665 6.00002C2.6665 9.26602 3.3705 11.6067 4.44717 13.0247C4.82917 13.5287 5.7605 13.372 6.1585 12.8674C6.42384 12.5307 6.7045 11.908 6.99984 11C7.1945 10.486 7.5945 9.99735 7.99984 10C8.40117 10 8.8065 10.4914 8.99984 11C9.29517 11.908 9.57584 12.53 9.84117 12.8667C10.2392 13.3727 11.1745 13.5287 11.5525 13.0247C12.6292 11.6067 13.3332 9.26669 13.3332 6.00002C13.3332 3.50669 12.0612 2.66669 10.6665 2.66669C9.71784 2.66669 8.71984 3.27402 7.99984 3.66669Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 6.25C4.25229 6.25 3.9165 6.58579 3.9165 7C3.9165 7.41421 4.25229 7.75 4.6665 7.75V6.25ZM6.49984 6.25H4.6665V7.75H6.49984V6.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.25C9.58579 6.25 9.25 6.58579 9.25 7C9.25 7.41421 9.58579 7.75 10 7.75V6.25ZM13 6.25H10V7.75H13V6.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_11139_6905",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 4,
    height: 4,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 4,
    height: 4,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 3,
    mask: "url(#path-4-inside-1_11139_6905)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11139_6905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTreatmentBold);
export default __webpack_public_path__ + "static/media/inTreatmentBold.8c4b79fd0c8a538a6f6978bf91008490.svg";
export { ForwardRef as ReactComponent };